module.exports = __webpack_public_path__ + "static/media/shape0_3.8a6ea585.obj";